import React from 'react';
import { Typography, Link } from '@mui/material';
import '../../style/Login.css';

interface CheckSignupMailProps {
}

const CheckSignupMail: React.FC<CheckSignupMailProps> = () => {
    const handleResendEmail = () => {
        console.log("Resend email clicked");
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Check your mail box
            </Typography>
            <Typography className='login_typography_content'>
                Didn’t get the mail?{' '}
                <Link
                    href="#"
                    onClick={handleResendEmail}
                    className='login_link'
                >
                    Click here to resend it.
                </Link>
            </Typography>
            <Typography className='login_typography_content'>
                Please DO NOT close this window before receiving verification mail.
            </Typography>
        </>
    );
};

export default CheckSignupMail;
